import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Lock, Mail, AlertCircle } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Button, Alert, Card } from '../design-system';

const Login = () => {
  const { user, login, signup, error } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // If user is already logged in, redirect to dashboard
    if (user) {
      return;
    }
  }, [user]);

  const handleLogin = () => {
    login();
  };

  const handleSignup = () => {
    signup();
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      backgroundColor: 'var(--color-background)',
      padding: 'var(--space-4)'
    }}>
      <Card variant="elevated" padding="large" style={{ maxWidth: '448px', width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: 'var(--space-6)' }}>
          <div 
            style={{ 
              margin: '0 auto',
              height: '64px',
              width: '64px',
              marginBottom: 'var(--space-4)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer'
            }}
            onClick={handleLogoClick}
          >
            <img 
              src="/icons/icon-192x192.png" 
              alt="TheraEngage Logo" 
              style={{ 
                height: '64px', 
                width: '64px',
                objectFit: 'contain'
              }} 
            />
          </div>
          <h2 
            style={{ 
              fontSize: 'var(--text-h1)', 
              fontWeight: 'var(--weight-bold)', 
              color: 'var(--color-text)',
              fontFamily: 'var(--font-heading)',
              margin: 0,
              cursor: 'pointer'
            }}
            onClick={handleLogoClick}
          >
            TheraEngage
          </h2>
        </div>
          {error && (
            <div style={{ marginBottom: 'var(--space-4)' }}>
              <Alert variant="error" size="medium">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <AlertCircle style={{ height: '16px', width: '16px', marginRight: 'var(--space-2)' }} />
                  <p style={{ margin: 0, fontSize: 'var(--text-caption)' }}>{error}</p>
                </div>
              </Alert>
            </div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
            <Button
              variant="primary"
              size="large"
              onClick={handleLogin}
              style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 'var(--space-2)' }}
            >
              <Mail style={{ height: '20px', width: '20px' }} />
              Sign In
            </Button>

            <div style={{ position: 'relative' }}>
              <div style={{ position: 'absolute', top: '50%', left: 0, right: 0, height: '1px', backgroundColor: 'rgba(0, 0, 0, 0.1)' }} />
              <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                <span style={{ 
                  padding: '0 var(--space-2)', 
                  backgroundColor: 'white', 
                  color: 'var(--color-text)', 
                  opacity: 0.6,
                  fontSize: 'var(--text-caption)'
                }}>
                  New to TheraEngage?
                </span>
              </div>
            </div>

            <Button
              variant="outline"
              size="large"
              onClick={handleSignup}
              style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 'var(--space-2)' }}
            >
              <Lock style={{ height: '20px', width: '20px' }} />
              Create Account
            </Button>
          </div>

        </Card>
    </div>
  );
};

export default Login; 